module.exports = __webpack_public_path__ + "img/zoomfromInterview.fc570bee.png";